import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

import IconButton from "../Buttons/IconButton";
import { PRIMARY_COLOR_TEXT } from "../../utils/colors";
import {
  galleryPublishButtonSx,
  getGallerySecondaryLabeledButtonSx,
} from "./galleryIconButtonStyles";

const GALLERY_LABELED_ACTION_VARIANT = {
  secondary: "secondary",
  primary: "primary",
};

const GalleryLabeledActionButton = ({
  variant = GALLERY_LABELED_ACTION_VARIANT.secondary,
  label,
  icon: Icon,
  onClick,
  loading = false,
  disabled = false,
  className,
}) => {
  const theme = useTheme();
  const isPrimary = variant === GALLERY_LABELED_ACTION_VARIANT.primary;

  return (
    <IconButton
      onClick={onClick}
      className={className}
      disabled={disabled}
      loading={loading}
      loaderColor={isPrimary ? "white" : PRIMARY_COLOR_TEXT}
      aria-label={label}
      sx={
        isPrimary
          ? { ...galleryPublishButtonSx, flexShrink: 0 }
          : getGallerySecondaryLabeledButtonSx(theme)
      }
      size="small"
      edge={false}
      type={isPrimary ? undefined : "icon"}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          whiteSpace: "nowrap",
        }}
      >
        {isPrimary ? (
          <Icon size={16} color="white" />
        ) : (
          <Icon
            sx={{
              color: PRIMARY_COLOR_TEXT,
              fill: PRIMARY_COLOR_TEXT,
            }}
          />
        )}
        <Typography
          variant="caption"
          component="span"
          sx={{
            color: isPrimary ? "#fff" : PRIMARY_COLOR_TEXT,
            fontWeight: 700,
            fontSize: "0.72rem",
            pt: isPrimary ? 0 : 0.2,
            lineHeight: 1,
          }}
        >
          {label}
        </Typography>
      </Box>
    </IconButton>
  );
};

export default GalleryLabeledActionButton;
